// @flow

import { localize, unescaped } from '@ta/common.i18n';

export function getHeader(index: number) {
  switch (index) {
    case 1:
      return localize('exp_free_24_hour_cancellation') /* Free 24-Hour Cancellation */;
    case 2:
      return localize('exp_low_price_guarantee') /* Low-price Guarantee */;
    default:
      return localize('exp_trusted_reviews_and_ratings') /* Trusted Reviews and Ratings */;
  }
}

export function getContent(index: number) {
  switch (index) {
    case 1:
      return localize(
        'exp_free_24_hour_cancellation_content',
      ) /* Plan changed? No problem. Change or cancel up to 24 hours before your experience */;
    case 2:
      return localize(
        'exp_low_price_guarantee_content',
      ) /* Enjoy the best experiences at the best price, every time */;
    default:
      return unescaped(
        localize('exp_trusted_reviews_and_ratings_content'),
      ) /* Know you're booking the best thanks to our helpful global traveler community */;
  }
}
